import React from 'react';
import PropTypes from 'prop-types';
import useLanguage from '../../../../hooks/useLanguage';

const PackagesModalHeader = ({ packagesData, selected }) => {
  const langToggle = useLanguage;
  return (
    <header className="packages-modal__header">
      <h3 className="packages-modal__header-title">
        <span className="packages-modal__header-title__first">
          {langToggle(
            packagesData.Titles.title_ua,
            packagesData.Titles.title_ru
          )}
        </span>
        <span className="packages-modal__header-title__second">
          {langToggle(
            packagesData.Titles.sub_title_ua,
            packagesData.Titles.sub_title_ru
          )}
        </span>
      </h3>
      <p className="packages-modal__header-subtitle">
        <span className="packages-modal__header-subtitle__rate">
          {langToggle(selected.rate_ua, selected.rate_ru)}
        </span>
        <span className="packages-modal__header-subtitle__separator">/</span>
        <span className="packages-modal__header-subtitle__duration">
          {langToggle(selected.duration_ua, selected.duration_ru)}
        </span>
      </p>
    </header>
  );
};

PackagesModalHeader.propTypes = {
  packagesData: PropTypes.object,
  selected: PropTypes.object,
};

export default PackagesModalHeader;
